import { useContext, useEffect, useState } from 'react';
import { CloseIconWhiteFill, DownloadInvoiceIcon } from '../assets/svgImages';
import OrderItemsPatientMobileView from './OrderItemsPatientMobileView';
import OrderItemsPatientView from './OrderItemsPatientView';
import PatientInfoPatientView from './PatientInfoPatientView';
import { useNavigate, useParams } from 'react-router-dom';
import {
  CancelOrderPurpose,
  OrderCancelationReason,
  OrderStatus,
  OrderStatusCode,
  PatientOrderInfo,
  PatientOrderProductsItem,
  ReactSelectOptionProp,
  SelectedOrder,
  SelectedOrderAction,
  ShopifyCustomerAddress,
} from '../interface/interface';
import { useAuth } from 'react-oidc-context';
import {
  getOrderInfoForPatient,
  getPatientOrderProductListByOrderId,
  requestForCancelOrder,
} from '../service';
import Loading from './Loading';
import instance from '../config/axios';
import saveAs from 'file-saver';
import CustomModal from './CustomModal';
import { UserContext } from '../context/userContext';
import showToast from './ToastComponent';
import moment from 'moment';
import Breadcrumbs from './Breadcrumbs';
import { CartContext } from '../context/cartContext';
import RequestToOrderCancellation from './RequestToOrderCancellation';
import InfoBox from './InfoBox';
import { cancelOrderRequestMessage } from '../helpers/cancelOrderRequestMessage';
import { YesNoButton } from './YesNoButton';
import loading from '../assets/loading.svg';
import { nativeService } from '../helpers/nativeService';
import { NativeResponseType } from '../interface/native.interface';

const OrderSummaryPatientView = () => {
  const { orderId } = useParams();
  const { user } = useAuth();
  const navigateTo = useNavigate();
  const {
    userDetail,
    iseRxDown,
    setLoadingEnable,
    isMobile,
    setActiveItem,
    nativeView,
  } = useContext(UserContext);

  const [selectedOrder, setOrder] = useState<SelectedOrder>();

  const [show, setShow] = useState<boolean>(true);

  const [patientSectionLoading, setPatientSectionLoader] =
    useState<boolean>(false);
  const [summaryData, setSummaryData] = useState<PatientOrderInfo>();

  const [orderProductList, setOrderProductList] = useState<
    Array<PatientOrderProductsItem>
  >([]);
  const [orderProductLoading, setOrderProductLoading] =
    useState<boolean>(false);

  const { cart } = useContext(CartContext);

  const [addressData, setAddressData] = useState<Array<ShopifyCustomerAddress>>(
    [],
  );

  const [open, setOpen] = useState(false);

  const [reason, setReason] = useState<string>('');
  const [loader, setLoader] = useState(false);
  const { setCart } = useContext(CartContext);
  const [shippingDetails, setShippingDetails] =
    useState<ShopifyCustomerAddress>();
  const [selectedReason, setSelectedReason] =
    useState<ReactSelectOptionProp | null>(null);
  const [isShippingButtonLoading, setIsShippingButtonLoading] =
    useState<boolean>(false);
  const [buttonLoadingEnable, setButtonLoadingEnable] =
    useState<boolean>(false);

  const addShipping = (shippingDetails: ShopifyCustomerAddress) => {
    setShippingDetails(shippingDetails);
  };

  const handleOtherReason = (value: string) => {
    setReason(value);
  };

  useEffect(() => {
    const ShippingDetailUpdate = async () => {
      if (shippingDetails) {
        try {
          await requestForCancel();
        } catch (err) {
          console.error(err);
        }
      }
    };

    ShippingDetailUpdate();
  }, [shippingDetails]);

  useEffect(() => {
    if (!open) {
      setReason('');
      setSelectedReason(null);
      setShippingDetails(undefined);
    } else {
      const shippingAddress: ShopifyCustomerAddress = {
        address1: summaryData?.address?.addressLine1 as string,
        address2: summaryData?.address?.addressLine2 as string,
        city: summaryData?.address?.city as string,
        // company: summaryData?.address?.specialDeliveryInstructions as string,
        country: 'Australia',
        first_name: summaryData?.address?.firstName as string,
        last_name: summaryData?.address?.lastName as string,
        phone: summaryData?.address?.phone?.toString(),
        province: summaryData?.address?.province as string,
        zip: summaryData?.address?.zipCode as string,
      };
      setAddressData([shippingAddress]);
    }
  }, [open]);

  useEffect(() => {
    setActiveItem('My Care Hub');
  }, [isMobile]);

  useEffect(() => {
    if (!orderId || isNaN(Number(orderId))) return navigateTo('/404');

    setOrder({
      orderId: Number(orderId),
      action: SelectedOrderAction.INTIAL,
    });
  }, [orderId]);

  useEffect(() => {
    if (!selectedOrder?.orderId || !user?.access_token) return;

    switch (selectedOrder.action) {
      case SelectedOrderAction.INTIAL:
        setPatientSectionLoader(true);
        getOrderInfoForPatient(user.access_token, selectedOrder.orderId).then(
          (data) => {
            if (typeof data === 'number') {
              if (data === 404) return navigateTo('/404');
              setPatientSectionLoader(false);
              return;
            }
            setSummaryData(data);
            setPatientSectionLoader(false);
          },
        );
        break;
      default:
        break;
    }
  }, [selectedOrder]);

  const requestForCancel = async () => {
    const reasonValue =
      selectedReason?.value === OrderCancelationReason.OTHER
        ? reason
        : (selectedReason?.value.toString() ?? '');
    const state = shippingDetails?.province;

    if (!reasonValue) {
      showToast({
        message: 'Empty reason not allowed',
        type: 'warning',
      });
      return;
    }

    if (
      selectedReason?.value ===
        OrderCancelationReason.SHIPPING_ADDRESS_INCORRECT &&
      (!state || state === 'Select')
    ) {
      showToast({
        message: 'Empty state not allowed',
        type: 'warning',
      });
      return;
    }

    if (!orderId || isNaN(Number(orderId)) || !user?.access_token) {
      return;
    }

    const data = {
      orderId: Number(orderId),
      reason: reasonValue,
      alternateAddress: shippingDetails!,
    };

    setIsShippingButtonLoading(true);
    setPatientSectionLoader(true);

    requestForCancelOrder(data, user?.access_token)
      .then((res) => {
        if (res.status === 200) {
          showToast({
            message: res.data.message,
            type: 'success',
          });
          setOpen(false);
          setOrder({
            orderId: Number(orderId),
            action: SelectedOrderAction.INTIAL,
          });
          setIsShippingButtonLoading(false);
          setPatientSectionLoader(false);
        } else {
          showToast({
            message: res.data.message,
            type: 'warning',
          });
          setIsShippingButtonLoading(false);
          setPatientSectionLoader(false);
        }
      })
      .catch((err) => {
        console.error(err);
        setIsShippingButtonLoading(false);
        setPatientSectionLoader(false);
      });
  };

  const callCart = async () => {
    try {
      const token = user?.access_token;

      const response = await instance('/api/v1/cart', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const responseData = response?.data;
      setCart(responseData);
    } catch (error: any) {
      showToast({
        message: 'Unable to fetch existing cart!',
        type: 'error',
      });
      return;
    }
  };

  const onReorder = async (id: number) => {
    if (!id) {
      console.error('Order ID passed as undefined!');
    }

    try {
      setLoader(true);

      const token = user?.access_token;
      const body = {
        order_id: id,
      };

      const response = await instance.post('/api/v1/cart/repeat', body, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      response.data.forEach((statusObject: any) => {
        if (statusObject.status === 200) {
          showToast({
            message: `${statusObject.title}: ${statusObject.message}`,
            type: 'success',
          });
        }
        if (statusObject.status === 405) {
          showToast({
            message: statusObject.message,
            type: 'warning',
          });
        }
      });
      await callCart();
    } catch (error) {
      console.error('Order repeat failed:', error);
    } finally {
      setLoader(false);
    }
  };

  const onDownload = async (id: number, code: string) => {
    if (!id) {
      console.error('Order ID passed as undefined!');
    }

    try {
      setButtonLoadingEnable(true);

      const token = user?.access_token;

      const response = await instance.get(`/api/v1/order/${id}/invoice`, {
        headers: {
          'Content-Type': 'application/pdf',
          Authorization: `Bearer ${token}`,
        },
        responseType: 'blob',
      });

      if (nativeView) {
        const reader = new FileReader();
        reader.onloadend = function () {
          let base64data = '';
          if (typeof reader.result === 'string') {
            base64data = reader.result.split(',')[1];
          }
          nativeService(
            JSON.stringify({
              type: NativeResponseType.DOWNLOAD_BLOB,
              filename: `${code}_Invoice.pdf`,
              base64: base64data,
            }),
          );
        };
        reader.readAsDataURL(response?.data);
        return;
      }
      saveAs(response.data, `${code}_Invoice.pdf`);
    } catch (error) {
      console.error('File download failed:', error);
    } finally {
      setButtonLoadingEnable(false);
    }
  };

  useEffect(() => {
    if (
      !user?.access_token ||
      !selectedOrder?.orderId ||
      selectedOrder.action !== SelectedOrderAction.INTIAL
    )
      return;

    setOrderProductLoading(true);
    getPatientOrderProductListByOrderId(
      user.access_token,
      selectedOrder.orderId.toString(),
    ).then((data) => {
      if (typeof data === 'number') {
        if (data === 404) navigateTo('/404');
        setOrderProductLoading(false);
        return;
      }

      setOrderProductList(data);
      setOrderProductLoading(false);
    });
  }, [selectedOrder]);

  useEffect(() => {
    if (!patientSectionLoading) {
      setLoadingEnable(false);
    } else {
      setLoadingEnable(true);
    }
  }, [patientSectionLoading]);

  if (loader) return <Loading />;

  return (
    <>
      {!patientSectionLoading ? (
        <div className="container-standard">
          {summaryData?.impersonatedBy && (
            <div
              className={`z-10 left-0 mb-0 sm:mb-5 text-center flex items-center fixed w-full p-3 3xl:top-[120px] text-white text-xs md:text-sm 
                font-semibold custom-close ${!show ? 'custom-hidden' : ''} ${localStorage.getItem('impersonateUser') && isMobile ? 'top-32' : 'top-20'}`}
            >
              <div className="relative">
                <p className="w-[95%] sm-land:w-full ">
                  This order has been placed on your behalf by a member of our
                  team.
                </p>

                <CloseIconWhiteFill
                  className="right-0 cursor-pointer w-2.5 md:w-3 font-bold absolute top-1/2 transform -translate-y-1/2"
                  onClick={() => setShow(false)}
                />
              </div>
            </div>
          )}

          <Breadcrumbs
            data={[
              {
                tag: 'a',
                className: `${show && isMobile && Boolean(summaryData?.impersonatedBy) ? 'mt-8 md:mt-0' : ''}`,
                href: '/orders',
                children: <>Orders</>,
              },
              {
                tag: 'p',
                className: `${show && isMobile && Boolean(summaryData?.impersonatedBy) ? 'mt-8 md:mt-0' : ''}`,
                children: <span>Order Summary</span>,
              },
            ]}
            hasBanner={show && isMobile && Boolean(summaryData?.impersonatedBy)}
          />
          <div className="flex justify-between items-baseline">
            <h2 className="text-xl md:text-2xl text-primary-blue-500 font-semibold pb-5">
              Order Summary for{' '}
              <span className="text-secondary-pink-600">
                #{summaryData?.invoiceId}
              </span>
            </h2>
            <button
              className="m-2 bg-white text-primary-blue-500 border border-primary-blue-500 p-3 2.5xl:px-6 2.5xl:py-3 text-sm font-semibold rounded"
              onClick={() => navigateTo(`/order/tracking/${orderId}`)}
            >
              View Tracking History
            </button>
          </div>

          {summaryData?.cancelOrderRequest?.status &&
          summaryData?.cancelOrderRequest?.status !==
            CancelOrderPurpose.Request ? (
            <InfoBox
              className="border border-blue-200 bg-blue-50 text-primary-blue-500 my-4"
              isIconEnable={true}
              iconClassName="w-6 fill-blue-400 mr-2"
              content={cancelOrderRequestMessage(
                summaryData?.cancelOrderRequest?.status,
              )}
              boldContent={summaryData?.cancelOrderRequest?.reason as string}
            />
          ) : null}

          {summaryData ? (
            <PatientInfoPatientView
              patient={{
                firstName: summaryData?.firstName,
                lastName: summaryData?.lastName,
                address: summaryData?.address,
                phone: summaryData?.phone,
                dob: summaryData.dob,
                email: summaryData.email,
                id: summaryData.patientId,
                company: summaryData.company,
              }}
            />
          ) : null}
          <div className="mt-8 bg-secondary-cornflowerblue-50 xl:bg-white rounded-md px-5 md:px-10 pt-4 pb-5 shadow mb-10">
            <div className="flex pb-4 xl:pb-8 flex-wrap items-start md:items-center flex-col md:flex-row">
              <div className="basis-1/2 xl:basis-1/3  items-center">
                <h3 className="text-xl 2.5xl:text-2xl text-primary-blue-500 font-semibold mr-3">
                  Order Details
                  <span className="text-secondary-pink-600 ml-2 text-sm 2xl:text-xl">
                    #{summaryData?.invoiceId}
                  </span>
                </h3>
                <p className="mb-1 mt-1">
                  <span className="text-primary-blue-500 text-base font-semibold">
                    Order Date:{' '}
                  </span>
                  <span className="text-secondary-pink-600 text-sm">
                    {summaryData?.orderCreatedDate
                      ? moment(summaryData?.orderCreatedDate).format(
                          'DD/MM/YYYY',
                        )
                      : '-'}
                  </span>
                </p>
                <p className="mb-4">
                  <span className="text-primary-blue-500 text-base font-semibold">
                    Dispensed Date:{' '}
                  </span>
                  <span className="text-secondary-pink-600 text-sm">
                    {summaryData?.orderDispensedDate
                      ? moment(summaryData?.orderDispensedDate).format(
                          'DD/MM/YYYY',
                        )
                      : '-'}
                  </span>
                </p>
              </div>
              <div className="basis-1/2 xl:basis-2/3 flex justify-end items-center">
                <p className="mr-6 text-sm xl:text-lg text-primary-blue-500 font-semibold flex items-center my-2 md:my-0">
                  <span
                    className="block rounded-full w-2.5 h-2.5 mr-2.5"
                    style={{
                      backgroundColor: summaryData?.currentStatus?.color,
                    }}
                  ></span>
                  <span className="text-center">
                    {summaryData?.currentStatus?.name
                      ? [
                          OrderStatus.PAUSED,
                          OrderStatus.AMENDING_DISPENSE,
                        ].includes(
                          summaryData.currentStatus?.name as OrderStatus,
                        )
                        ? 'In Progress'
                        : summaryData.currentStatus?.name
                      : '-'}
                  </span>
                </p>
                <button
                  className="hidden xl:block bg-primary-blue-500 text-white p-3 2.5xl:px-6 2.5xl:py-3 text-sm 2.5xl:text-base 
                  font-semibold rounded mr-6"
                  onClick={() => {
                    navigateTo('/prescriptions');
                  }}
                >
                  Manage my medications
                </button>
                <button
                  className={`hidden xl:block bg-secondary-cornflowerblue-500 text-white p-3 2.5xl:px-6 2.5xl:py-3 text-sm 
                  2.5xl:text-base font-semibold rounded mr-6 
                  ${!userDetail?.supportingParams?.isUserAllowedToOrder || iseRxDown ? 'cursor-not-allowed	opacity-50' : ''}`}
                  onClick={() => onReorder(summaryData?.orderId as number)}
                >
                  Order again
                </button>
                <button
                  className={`hidden xl:block bg-primary-red-400 text-white p-3 2.5xl:px-6 2.5xl:py-3 text-sm 2.5xl:text-base 
                  font-semibold rounded ${summaryData?.currentStatus?.name !== OrderStatus.ORDERED && 'cursor-not-allowed opacity-50'}`}
                  onClick={() => setOpen(true)}
                  disabled={
                    summaryData?.currentStatus?.name !== OrderStatus.ORDERED
                  }
                >
                  Request to Cancel
                </button>
              </div>
            </div>
            <div className="hidden xl:block">
              {!orderProductLoading ? (
                <OrderItemsPatientView data={orderProductList} />
              ) : null}
            </div>
            <div className="block xl:hidden">
              {!orderProductLoading ? (
                <OrderItemsPatientMobileView data={orderProductList} />
              ) : null}
            </div>
            <button
              className="block xl:hidden bg-primary-blue-500 text-white px-6 py-3 text-sm md:text-base font-semibold rounded w-4/5 
              lg:w-60 mx-auto mt-10"
              onClick={() => {
                navigateTo('/prescriptions');
              }}
            >
              Manage my medicines
            </button>
            <button
              className="block xl:hidden bg-secondary-cornflowerblue-500 text-white px-6 py-3 text-sm md:text-base font-semibold 
              rounded w-4/5 lg:w-60 mx-auto mt-4"
              onClick={() => onReorder(summaryData?.orderId as number)}
            >
              Order again
            </button>
            <button
              className={`block xl:hidden bg-primary-red-400 text-white px-6 py-3 text-sm md:text-base font-semibold rounded w-4/5 
              lg:w-60 mx-auto mt-4 ${summaryData?.currentStatus?.name !== OrderStatus.ORDERED ? 'opacity-50' : ''}`}
              onClick={() => setOpen(true)}
              disabled={summaryData?.currentStatus?.name !== OrderStatus.ORDERED}
            >
              Request to Cancel
            </button>
            <div className="flex justify-center xl:justify-end mt-8 xl:mr-5">
              <button
                className={`border-0 bg-transparent text-primary-blue-500 font-semibold font-base flex items-center mt-2 md:mt-0 
                xl:ml-3 ${(summaryData?.currentStatus?.id as number) < OrderStatusCode.DISPENSED && 'cursor-not-allowed	opacity-50'}`}
                onClick={() =>
                  onDownload(
                    summaryData?.orderId as number,
                    summaryData?.orderCode as string,
                  )
                }
                disabled={
                  (summaryData?.currentStatus?.id as number) <
                  OrderStatusCode.DISPENSED
                }
              >
                <span>Download Invoice</span>
                {buttonLoadingEnable ? (
                  <div className="col-span-2 xl:col-span-1 text-end p-1">
                    <img
                      height={'20px'}
                      width={'20px'}
                      src={loading}
                      alt="Loading"
                    />
                  </div>
                ) : (
                  <DownloadInvoiceIcon className="ml-3" />
                )}{' '}
              </button>
            </div>
            <div className="flex justify-end">
              <div className="w-full md:w-9/12 lg:w-5/12 rounded-md bg-secondary-cornflowerblue-50 my-5">
                <div className="w-9/12 mx-auto pt-8">
                  {summaryData?.discount !== '0.00' && (
                    <p className="flex justify-between pb-3 items-center">
                      <label className="text-primary-blue-400 text-base md:text-xl font-semibold">
                        Discounts
                      </label>
                      <span className="text-primary-blue-500 text-sm md:text-lg font-regular">
                        - ${summaryData?.discount}
                      </span>
                    </p>
                  )}
                  {summaryData?.appliedGiftCards !== '0.00' && (
                    <p className="flex justify-between pb-3 items-center">
                      <label className="text-primary-blue-400 text-base md:text-xl font-semibold">
                        Gift Cards Applied
                      </label>
                      <span className="text-primary-blue-500 text-sm md:text-lg font-regular">
                        - ${summaryData?.appliedGiftCards}
                      </span>
                    </p>
                  )}
                  <p className="flex justify-between pb-3 items-center">
                    <label className="text-primary-blue-400 text-base md:text-xl font-semibold">
                      Subtotal
                    </label>
                    <span className="text-primary-blue-500 text-sm md:text-lg font-regular">
                      ${summaryData?.subTotal}
                    </span>
                  </p>
                  <p className="flex justify-between pb-3 items-center">
                    <label className="text-primary-blue-400 text-base md:text-xl font-semibold">
                      Dispensing & Fulfilment Fee
                    </label>
                    <span className="text-primary-blue-500 text-sm md:text-lg font-regular">
                      ${summaryData?.creditCardProcessingFee}
                    </span>
                  </p>
                  <p className="flex justify-between pb-3 items-center">
                    <label className="text-primary-blue-400 text-base md:text-xl font-semibold">
                      Shipping
                    </label>
                    <span className="text-primary-blue-500 text-sm md:text-lg font-regular">
                      ${summaryData?.shippingCost?.toFixed(2)}
                    </span>
                  </p>
                  {summaryData?.taxes !== '0.00' ? (
                    <p className="flex justify-between pb-5 items-center">
                      <label className="text-primary-blue-400 text-base md:text-xl font-semibold">
                        Taxes
                      </label>
                      <span className="text-primary-blue-500 text-sm md:text-lg font-regular">
                        ${summaryData?.taxes}
                      </span>
                    </p>
                  ) : (
                    <></>
                  )}
                </div>
                <div className="refund-block">
                  <hr className="w-11/12 mb-5 mx-auto border-secondary-cornflowerblue-400"></hr>
                  <div className="w-9/12 mx-auto">
                    <p className="flex justify-between pb-5 items-center">
                      <label className="text-primary-blue-400 text-base md:text-xl font-semibold">
                        Invoice Total
                      </label>
                      <span className="text-primary-blue-500 text-sm md:text-lg font-regular">
                        ${summaryData?.invoiceTotal}
                      </span>
                    </p>
                  </div>
                  <hr className="w-11/12 mb-5 mx-auto border-secondary-cornflowerblue-400"></hr>
                  {summaryData?.refunded && (
                    <div className="w-9/12 mx-auto">
                      <p className="flex justify-between pb-5 items-center">
                        <label className="text-primary-blue-400 text-base md:text-xl font-semibold">
                          Refunded
                        </label>
                        <span className="text-primary-blue-500 text-sm md:text-lg font-regular">
                          -${summaryData.refunded}
                        </span>
                      </p>
                    </div>
                  )}
                </div>
                <div className="bg-primary-blue-500 rounded-b-md">
                  <p className="flex justify-between items-center w-9/12 py-6 mx-auto">
                    <label className="text-white text-base md:text-xl font-semibold">
                      Net Payment
                    </label>
                    <span className="text-white text-sm md:text-lg font-regular">
                      ${summaryData?.netPayment}
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <Loading />
      )}

      <CustomModal
        isOpen={open}
        onClose={() => setOpen(false)}
        header={'Request to Cancel'}
        footer={
          selectedReason?.value !==
          OrderCancelationReason.SHIPPING_ADDRESS_INCORRECT ? (
            <YesNoButton
              yesLabel="Yes"
              noLabel="Cancel"
              yesOnClick={() => requestForCancel()}
              noOnClick={() => setOpen(false)}
            />
          ) : null
        }
        modalSize={'w-11/12 md:w-10/12 lg:w-7/12 xl:w-5/12'}
        modalBodyClass={'max-h-[40rem] overflow-y-auto overflow-x-hidden'}
        disableBackdropClose={true}
      >
        {
          <RequestToOrderCancellation
            orderId={orderId}
            cart={cart}
            addressList={addressData}
            addShipping={addShipping}
            handleSelectedReason={(value) => setSelectedReason(value)}
            handleOtherReason={handleOtherReason}
            editShippingEnabled={true}
            isForRequestToCancel={true}
            isButtonLoadingEnable={isShippingButtonLoading}
            selectedReason={selectedReason}
            reason={reason}
          />
        }
      </CustomModal>
    </>
  );
};

export default OrderSummaryPatientView;
